import { Balance } from '@epilot/customer-portal-client'

export const MOCK_BALANCE: Balance = {
  balance_currency: 'EUR',
  balance: 165638,
  balance_decimal: 1656.38
}
